
// import React, { useState, useEffect, useRef } from 'react';
// import {
//   Box,
//   Typography,
//   Paper,
//   LinearProgress,
//   Grid,
//   Chip,
//   Alert,
//   Button,
//   CircularProgress,
//   Stack,
//   Divider,
//   Fade,
// } from '@mui/material';
// import { styled, keyframes } from '@mui/material/styles';
// import {
//   Security,
//   Speed,
//   Timer,
//   CheckCircleOutline,
//   ErrorOutline,
//   Troubleshoot,
//   Policy,
// } from '@mui/icons-material';
// import api from '../../services/api';  // ← CHANGED: Use api client instead of axios
// import { useNavigate, useParams } from 'react-router-dom';
// import { useSnackbar } from 'notistack';

// // API_BASE removed - no longer needed

// // --- Custom Animations & Styled Components ---
// const pulseAnimation = keyframes`
//   0% { transform: scale(0.98); opacity: 0.85; }
//   50% { transform: scale(1.05); opacity: 1; }
//   100% { transform: scale(0.98); opacity: 0.85; }
// `;

// const PulsingIconBox = styled(Box)(({ theme }) => ({
//   display: 'inline-flex',
//   padding: theme.spacing(2.5),
//   borderRadius: '50%',
//   backgroundColor: theme.palette.primary.main + '15',
//   color: theme.palette.primary.main,
//   animation: `${pulseAnimation} 2s infinite ease-in-out`,
//   marginBottom: theme.spacing(3),
// }));

// export default function ScanProgress() {
//   const { scanId } = useParams();
//   const navigate = useNavigate();
//   const { enqueueSnackbar } = useSnackbar();
  
//   const [status, setStatus] = useState<'processing' | 'completed' | 'failed'>('processing');
//   const [error, setError] = useState<string | null>(null);
//   const [elapsedTime, setElapsedTime] = useState(0);
//   const startTimeRef = useRef<number>(Date.now());

//   useEffect(() => {
//     if (!scanId) {
//       navigate('/scans');
//       return;
//     }

//     // Start timer
//     const timerInterval = setInterval(() => {
//       const elapsed = Math.floor((Date.now() - startTimeRef.current) / 1000);
//       setElapsedTime(elapsed);
//     }, 1000);

//     // Poll for completion
//     const pollInterval = setInterval(async () => {
//       try {
//         // ← CHANGED: Use api instead of axios
//         const response = await api.get(`/v1/scan/${scanId}`);
//         const data = response.data;

//         if (data.status === 'completed') {
//           setStatus('completed');
//           clearInterval(timerInterval);
//           clearInterval(pollInterval);
//           enqueueSnackbar('Scan completed successfully', { variant: 'success' });
//           setTimeout(() => {
//             navigate(`/scans/${scanId}/results`);
//           }, 1500);
//         } else if (data.status === 'failed') {
//           setStatus('failed');
//           setError(data.error);
//           clearInterval(timerInterval);
//           clearInterval(pollInterval);
//           enqueueSnackbar(data.error || 'Scan failed', { variant: 'error' });
//         }
//       } catch (err) {
//         console.error('Error polling scan status:', err);
//       }
//     }, 2000);

//     return () => {
//       clearInterval(timerInterval);
//       clearInterval(pollInterval);
//     };
//   }, [scanId, navigate, enqueueSnackbar]);

//   const formatTime = (seconds: number) => {
//     const mins = Math.floor(seconds / 60);
//     const secs = seconds % 60;
//     return `${mins}:${secs.toString().padStart(2, '0')}`;
//   };

//   // --- Render: Completed State ---
//   if (status === 'completed') {
//     return (
//       <Fade in={true} timeout={600}>
//         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', p: 3 }}>
//           <Paper elevation={0} sx={{ textAlign: 'center', p: 6, maxWidth: 480, width: '100%', border: '1px solid', borderColor: 'divider', borderRadius: 4 }}>
//             <CheckCircleOutline sx={{ fontSize: 72, color: 'success.main', mb: 2 }} />
//             <Typography variant="h5" fontWeight={600} gutterBottom>Analysis Complete</Typography>
//             <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
//               Security checks finished successfully. Redirecting to your results dashboard...
//             </Typography>
//             <CircularProgress size={28} thickness={5} color="success" />
//           </Paper>
//         </Box>
//       </Fade>
//     );
//   }

//   // --- Render: Failed State ---
//   if (status === 'failed') {
//     return (
//       <Fade in={true} timeout={400}>
//         <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh', p: 3 }}>
//           <Paper elevation={0} sx={{ p: 5, maxWidth: 480, width: '100%', border: '1px solid', borderColor: 'error.light', borderRadius: 4 }}>
//             <Box sx={{ textAlign: 'center', mb: 3 }}>
//               <ErrorOutline sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
//               <Typography variant="h5" fontWeight={600}>Scan Interrupted</Typography>
//             </Box>
//             <Alert severity="error" sx={{ mb: 4, borderRadius: 2 }}>
//               {error || 'An unexpected error occurred during the security analysis.'}
//             </Alert>
//             <Stack direction="row" spacing={2} justifyContent="center">
//               <Button variant="outlined" color="inherit" onClick={() => navigate('/scans')} sx={{ px: 3 }}>
//                 Cancel
//               </Button>
//               <Button variant="contained" color="error" onClick={() => navigate('/scans/new')} disableElevation sx={{ px: 3 }}>
//                 Start New Scan
//               </Button>
//             </Stack>
//           </Paper>
//         </Box>
//       </Fade>
//     );
//   }

//   // --- Render: Processing State ---
//   return (
//     <Fade in={true}>
//       <Box sx={{ p: 3, maxWidth: 650, mx: 'auto', mt: { xs: 2, md: 6 } }}>
//         <Paper 
//           elevation={0} 
//           sx={{ 
//             borderRadius: 4, 
//             border: '1px solid', 
//             borderColor: 'divider',
//             overflow: 'hidden',
//             bgcolor: 'background.paper'
//           }}
//         >
//           {/* Header Area */}
//           <Box sx={{ p: 4, textAlign: 'center', borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'grey.50' }}>
//             <PulsingIconBox>
//               <Troubleshoot sx={{ fontSize: 48 }} />
//             </PulsingIconBox>
            
//             <Typography variant="h5" sx={{ fontWeight: 600, mb: 1, letterSpacing: '-0.5px' }}>
//               Analyzing Infrastructure
//             </Typography>
            
//             <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
//               Target ID: <Typography component="span" fontWeight={600} color="text.primary">{scanId?.substring(0, 8)}</Typography>
//             </Typography>

//             <Box sx={{ width: '100%', maxWidth: 400, mx: 'auto' }}>
//               <LinearProgress 
//                 sx={{ 
//                   height: 6, 
//                   borderRadius: 3,
//                   bgcolor: 'grey.200',
//                   '& .MuiLinearProgress-bar': { borderRadius: 3 }
//                 }} 
//               />
//             </Box>
//           </Box>

//           {/* Details Area */}
//           <Box sx={{ p: 4 }}>
//             <Grid container spacing={4} sx={{ mb: 4 }}>
//               {/* Elapsed Time */}
//               <Grid size={{ xs: 6 }}>
//                 <Stack direction="row" spacing={2} alignItems="center">
//                   <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: 'grey.100', display: 'flex' }}>
//                     <Timer color="action" fontSize="small" />
//                   </Box>
//                   <Box>
//                     <Typography variant="caption" color="text.secondary" fontWeight={500} textTransform="uppercase" letterSpacing="0.5px">
//                       Elapsed Time
//                     </Typography>
//                     <Typography variant="h6" fontWeight={600} sx={{ lineHeight: 1.2 }}>
//                       {formatTime(elapsedTime)}
//                     </Typography>
//                   </Box>
//                 </Stack>
//               </Grid>

//               {/* Scan Mode */}
//               <Grid size={{ xs: 6 }}>
//                 <Stack direction="row" spacing={2} alignItems="center">
//                   <Box sx={{ p: 1.5, borderRadius: 2, bgcolor: 'grey.100', display: 'flex' }}>
//                     <Speed color="action" fontSize="small" />
//                   </Box>
//                   <Box>
//                     <Typography variant="caption" color="text.secondary" fontWeight={500} textTransform="uppercase" letterSpacing="0.5px">
//                       Engine Mode
//                     </Typography>
//                     <Typography variant="h6" fontWeight={600} sx={{ lineHeight: 1.2 }}>
//                       Parallel
//                     </Typography>
//                   </Box>
//                 </Stack>
//               </Grid>
//             </Grid>

//             <Divider sx={{ mb: 4 }} />

//             {/* Scope Tags */}
//             <Typography variant="subtitle2" color="text.secondary" gutterBottom sx={{ mb: 2 }}>
//               Scan Scope
//             </Typography>
//             <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap>
//               <Chip icon={<Security fontSize="small" />} label="12 Security Groups" size="small" variant="outlined" />
//               <Chip icon={<Policy fontSize="small" />} label="104 Indicators" size="small" variant="outlined" />
//               <Chip label="High-Speed Validation" size="small" color="primary" sx={{ bgcolor: 'primary.50', color: 'primary.dark', fontWeight: 500, border: 'none' }} />
//             </Stack>
//           </Box>
//         </Paper>
        
//         {/* Actions */}
//         <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
//           <Button 
//             color="inherit" 
//             onClick={() => navigate('/scans')}
//             sx={{ color: 'text.secondary', '&:hover': { color: 'error.main', bgcolor: 'error.50' } }}
//           >
//             Cancel Execution
//           </Button>
//         </Box>
//       </Box>
//     </Fade>
//   );
// }

import React, { useEffect, useRef, useState } from 'react';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import { useTheme as useCustomTheme } from '../../context/ThemeContext';
import { T, sans, card, topBtn } from '../Vendors/VendorDetails';
import { VendorLogo } from '../VendorRequests/VendorRequests';
import ScanTypeButton, { useVendorScan } from '../../components/ScanTypeButton';
import { findingState } from '../../components/IndicatorDetailModal';

const POLL_MS = 2000;
const REDIRECT_SECONDS = 3;

// One scan's status/results; shared with ScanResults so both pages read the same cache entry.
export const scanQueryOptions = (scanId: string) => queryOptions({
  queryKey: ['scan', scanId],
  queryFn: async () => (await api.get(`/v1/scan/${scanId}`)).data as any,
});

// The scan engine's 16 groups (services/scan_engine.py scan_groups), by id, in the order shown.
const SECURITY_GROUPS: [number, string][] = [
  [1, 'Domain and DNS'], [2, 'Network and attack surface'], [3, 'Web application'], [4, 'TLS / encryption'],
  [5, 'Identity and threat intel'], [6, 'Cloud security'], [7, 'Infrastructure'], [8, 'Subdomains'],
];
const CONTEXT_GROUPS: [number, string][] = [
  [9, 'Company profile'], [10, 'Funding and ownership'], [11, 'Reputation and ESG'], [12, 'Legal and regulatory'],
  [13, 'Market intelligence'], [14, 'Cubit score'], [15, 'Patching cadence'], [16, 'Security certifications'],
];
const GROUP_NAME = Object.fromEntries([...SECURITY_GROUPS, ...CONTEXT_GROUPS]) as Record<number, string>;

const clock = (seconds: number) => {
  const s = Math.max(0, Math.round(seconds));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};

const timeOfDay = (iso?: string) => {
  if (!iso) return '';
  const d = new Date(iso);
  return isNaN(d.getTime()) ? '' : d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

type GroupState = 'done' | 'running' | 'waiting';

export default function ScanProgress() {
  const { scanId } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { mode } = useCustomTheme();
  const isDark = mode === 'dark';
  const canScan = !!user && user.role !== 'viewer';

  const ink = isDark ? '#e2e8f0' : T.ink;
  const sub = isDark ? '#94a3b8' : T.slate;
  const faint = isDark ? '#64748b' : T.muted;
  const line = isDark ? '#1f1f1f' : T.bdr;
  const track = isDark ? '#1a1a1a' : T.surface2;
  const blue = isDark ? '#60A5FA' : T.blue;
  const blueBg = isDark ? '#0c2a4a' : T.blueBg;
  const green = isDark ? '#4ade80' : T.grn;
  const red = isDark ? '#f87171' : T.red;

  useEffect(() => {
    if (!scanId) navigate('/vendors');
  }, [scanId, navigate]);

  const scanQuery = useQuery({
    ...scanQueryOptions(scanId ?? ''),
    enabled: !!scanId,
    retry: false,
    refetchInterval: query => {
      const s = query.state.data?.status;
      return s === 'completed' || s === 'failed' || (!query.state.data && query.state.status === 'error') ? false : POLL_MS;
    },
  });
  const scan = scanQuery.data;

  // Polling errors keep the last known state on screen; only a failed first load is shown as an error.
  let status: 'checking' | 'processing' | 'completed' | 'failed' = 'checking';
  let error: string | null = null;
  // A scan we couldn't load at all (not found, or the status request failed) is not a scan that stopped.
  let loadProblem: string | null = null;
  if (scan?.status === 'completed' || scan?.status === 'processing') status = scan.status;
  else if (scan?.status === 'failed') { status = 'failed'; error = scan.error || null; }
  else if (!scan && scanQuery.isError) {
    status = 'failed';
    loadProblem = (scanQuery.error as any)?.response?.status === 404
      ? "This scan doesn't exist, or it finished long enough ago that its live status has expired. Its results, if it finished, are in the vendor's scan history."
      : "The scan's status couldn't be loaded. Check your connection and reload the page.";
  }

  // The scan's own start time (not when this page opened), so the clock is right after a reload.
  const startedAt: string | undefined = scan?.created_at || scan?.started_at;
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (status !== 'processing') return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [status]);
  const elapsed = startedAt ? (now - new Date(startedAt).getTime()) / 1000 : 0;

  // Completed: count down, then open the results (once per scan).
  const [countdown, setCountdown] = useState(REDIRECT_SECONDS);
  const redirected = useRef(false);
  useEffect(() => {
    if (status !== 'completed') return;
    if (countdown <= 0) {
      if (!redirected.current) { redirected.current = true; navigate(`/scans/${scanId}/results`); }
      return;
    }
    const t = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [status, countdown, scanId, navigate]);

  const rescan = useVendorScan();

  const progress = scan?.progress || {};
  const groupsStatus: Record<string, { status?: string; finished_s?: number | null }> = progress.groups_status || {};
  const phase: string = progress.current_group || '';
  // Before the worker picks the scan up, and while a deep scan is still finding subdomains, no group has started.
  const notStarted = !Object.keys(groupsStatus).length || /^(initializ|discovering)/i.test(phase);
  const groupState = (id: number): GroupState =>
    groupsStatus[id]?.status === 'completed' ? 'done' : notStarted ? 'waiting' : 'running';
  const doneCount = Object.values(groupsStatus).filter(g => g?.status === 'completed').length;
  const totalGroups = 16;
  const pct = Math.round((doneCount / totalGroups) * 100);
  const running = [...SECURITY_GROUPS, ...CONTEXT_GROUPS].filter(([id]) => groupState(id) === 'running').map(([id]) => GROUP_NAME[id]);

  const vendorName: string = scan?.company_name || scan?.domain || 'this vendor';
  const domain: string = scan?.domain || '';
  const isDeep = scan?.scan_type === 'deep';
  const vendorPath = scan?.vendor_id ? `/vendors/${scan.vendor_id}` : '/vendors';

  const page: React.CSSProperties = { fontFamily: sans, maxWidth: 920, margin: '0 auto', padding: '28px 20px 48px', color: ink };
  const keyframes = (
    <style>{`
      @keyframes spSpin { to { transform: rotate(360deg); } }
      .sp-spin { display:inline-block; width:14px; height:14px; border-radius:50%; border:2px solid ${blueBg}; border-top-color:${blue}; animation: spSpin .9s linear infinite; flex:none; }
      @media (prefers-reduced-motion: reduce) { .sp-spin { animation-duration: 3s; } }
    `}</style>
  );

  const header = (rightSide?: React.ReactNode) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
      {domain ? <VendorLogo name={vendorName} domain={domain} size={40} isDark={isDark} /> : null}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 17, fontWeight: 600 }}>
          {status === 'completed' ? 'Scan finished' : status === 'failed' ? (loadProblem ? 'Scan unavailable' : 'Scan stopped') : `Scanning ${vendorName}`}
        </div>
        <div style={{ fontSize: 12, color: sub, marginTop: 2 }}>
          {[domain, scan?.scan_type ? (isDeep ? 'Deep scan' : 'Fast scan') : null, scan?.scan_ref,
            status === 'completed'
              // a finished scan's created_at is when it was saved, not when it started
              ? (timeOfDay(scan?.completed_at || scan?.created_at) ? `finished ${timeOfDay(scan?.completed_at || scan?.created_at)}` : null)
              : startedAt ? `started ${timeOfDay(startedAt)}${scan?.started_by ? ` by ${scan.started_by}` : ''}` : null]
            .filter(Boolean).join(' · ')}
        </div>
      </div>
      {rightSide}
    </div>
  );

  // ── Loading ───────────────────────────────────────────────────────────
  if (status === 'checking') {
    return (
      <div style={page}>{keyframes}
        <div style={{ ...card(isDark), display: 'flex', alignItems: 'center', gap: 10, fontSize: 13, color: sub }}>
          <span className="sp-spin" /> Loading the scan…
        </div>
      </div>
    );
  }

  // ── Finished ──────────────────────────────────────────────────────────
  if (status === 'completed') {
    const indicators: any[] = Array.isArray(scan?.indicators) ? scan.indicators : [];
    // Same rule as the results page's "Open risks" tab, so the two numbers always agree.
    const openRisks = indicators.filter(i => {
      const label = findingState(i).label;
      return label !== 'Passed' && label !== 'Not tested';
    }).length;
    const score = scan?.overall_score;
    return (
      <div style={page}>{keyframes}
        <div style={card(isDark)}>
          {header()}
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 18 }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={green} strokeWidth="2" aria-hidden="true">
              <circle cx="12" cy="12" r="9" /><path d="M8 12.5l2.5 2.5L16 9.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 15, fontWeight: 600 }}>
                Scan complete{typeof score === 'number' ? ` · ${Math.round(score)} / 100` : ''}
              </div>
              <div style={{ fontSize: 12, color: sub, marginTop: 2 }}>
                {openRisks} open risk{openRisks === 1 ? '' : 's'} · opening the results in {Math.max(countdown, 0)}s
              </div>
            </div>
            <button style={topBtn(true, isDark)} onClick={() => { redirected.current = true; navigate(`/scans/${scanId}/results`); }}>
              View results now
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ── Failed ────────────────────────────────────────────────────────────
  if (status === 'failed') {
    return (
      <div style={page}>{keyframes}
        <div style={{ ...card(isDark), border: `1px solid ${isDark ? '#7f1d1d' : T.redBdr}` }}>
          {header()}
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginTop: 18 }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={red} strokeWidth="2" aria-hidden="true" style={{ flex: 'none', marginTop: 1 }}>
              <path d="M12 3l9.5 17h-19L12 3z" strokeLinejoin="round" /><path d="M12 10v4M12 17.5v.01" strokeLinecap="round" />
            </svg>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 15, fontWeight: 600 }}>
                {loadProblem ? "This scan couldn't be shown" : 'The scan stopped before it finished'}
              </div>
              <div style={{ fontSize: 12, color: sub, marginTop: 4 }}>
                {loadProblem || "Nothing was scored, and the vendor's previous results are unchanged."}
              </div>
              {error && <div style={{ fontSize: 12, color: faint, marginTop: 6, overflowWrap: 'anywhere' }}>Reason: {error}</div>}
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8, marginTop: 16, flexWrap: 'wrap' }}>
            {canScan && scan?.vendor_id && (
              <ScanTypeButton
                label="Scan again" isDark={isDark} buttonStyle={topBtn(true, isDark)}
                busy={rescan.isPending}
                onPick={depth => rescan.mutate({ vendorId: scan.vendor_id, depth })}
              />
            )}
            <button style={topBtn(false, isDark)} onClick={() => navigate(vendorPath)}>
              {scan?.vendor_id ? 'Back to vendor' : 'Back to vendors'}
            </button>
          </div>
          {rescan.isError && (
            <div style={{ fontSize: 12, color: red, marginTop: 10 }}>
              {(rescan.error as any)?.response?.data?.detail?.message || (rescan.error as any)?.response?.data?.detail || "The scan couldn't be started."}
            </div>
          )}
        </div>
      </div>
    );
  }

  // ── Running ───────────────────────────────────────────────────────────
  const groupRow = ([id, label]: [number, string]) => {
    const state = groupState(id);
    const finished = groupsStatus[id]?.finished_s;
    return (
      <div key={id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderTop: `1px solid ${line}`, fontSize: 13 }}>
        {state === 'done' ? (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={green} strokeWidth="2.2" aria-hidden="true" style={{ flex: 'none' }}>
            <circle cx="12" cy="12" r="9" /><path d="M8 12.5l2.5 2.5L16 9.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        ) : state === 'running' ? (
          <span className="sp-spin" aria-hidden="true" />
        ) : (
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={faint} strokeWidth="2" strokeDasharray="3 3" aria-hidden="true" style={{ flex: 'none' }}>
            <circle cx="12" cy="12" r="9" />
          </svg>
        )}
        <span style={{ flex: 1, minWidth: 0, color: state === 'waiting' ? sub : ink }}>{label}</span>
        {state === 'done' ? (
          <span style={{ fontSize: 12, color: sub }}>{typeof finished === 'number' ? clock(finished) : 'Done'}</span>
        ) : state === 'running' ? (
          <span style={{ fontSize: 11, fontWeight: 600, color: blue, background: blueBg, borderRadius: 999, padding: '2px 8px' }}>Running</span>
        ) : (
          <span style={{ fontSize: 12, color: faint }}>Waiting</span>
        )}
      </div>
    );
  };
  const groupCard = (title: string, groups: [number, string][]) => {
    const done = groups.filter(([id]) => groupState(id) === 'done').length;
    return (
      <div style={card(isDark)}>
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 6 }}>
          {title} <span style={{ fontWeight: 400, color: sub, fontSize: 12 }}>{done} of {groups.length}</span>
        </div>
        {groups.map(groupRow)}
      </div>
    );
  };

  let nowLine: string;
  if (/^initializ/i.test(phase) || !Object.keys(groupsStatus).length) nowLine = 'Waiting for a scanner to pick this up…';
  else if (/^discovering/i.test(phase)) nowLine = 'Finding subdomains to include in the deep scan…';
  else if (running.length === 0) nowLine = 'Scoring and saving the results…';
  else if (running.length <= 2) nowLine = `Still checking ${running.join(' and ')}`;
  else nowLine = `${running.length} check groups running in parallel`;

  return (
    <div style={page}>{keyframes}
      <div style={card(isDark)}>
        {header(
          <button style={topBtn(false, isDark)} onClick={() => navigate(vendorPath)}>
            {scan?.vendor_id ? 'Back to vendor' : 'Back to vendors'}
          </button>,
        )}
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, marginTop: 20, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 30, fontWeight: 600, letterSpacing: '-.5px' }}>{pct}%</span>
          <span style={{ fontSize: 12, color: sub }}>
            {doneCount} of {totalGroups} check groups done · {clock(elapsed)} elapsed · {isDeep ? 'deep scans can take several minutes' : 'fast scans usually take 1 to 2 minutes'}
          </span>
        </div>
        <div style={{ height: 8, background: track, borderRadius: 999, marginTop: 10, overflow: 'hidden' }}
          role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={pct} aria-label="Scan progress">
          <div style={{ width: `${pct}%`, height: '100%', background: blue, borderRadius: 999, transition: 'width .6s ease' }} />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 10, fontSize: 12, color: sub }}>
          <span className="sp-spin" aria-hidden="true" /> {nowLine}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 12, marginTop: 12 }}>
        {groupCard('Security checks', SECURITY_GROUPS)}
        {groupCard('Business and risk context', CONTEXT_GROUPS)}
      </div>

      <div style={{ fontSize: 12, color: sub, marginTop: 12 }}>
        You can leave this page. The scan keeps running, and the vendor's score updates on its own when it finishes.
      </div>
    </div>
  );
}
